<div class="components-wrapper" *ngIf="showForm || filtersActive">
  <div class="p-4">
    <form class="row" #tempFilterTabla="ngForm" (submit)="onSearchClicked()">
      <div class="col-md-12" *ngIf="showForm">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label for="selectedProperty">Propiedad: </label>
              <ng-select
                [items]="filterProperties"
                bindLabel="text"
                [(ngModel)]="selectedProperty"
                (change)="onPropertyChanged()"
                name="selectedProperty"
              ></ng-select>
            </div>
          </div>

          <!-- CODIGO -->
          <div class="col-md-4" *ngIf="selectedProperty?.value === 'identificacion'">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="identificacion">Identificación:</label>
                  <input
                    type="text"
                    class="form-control"
                    name="identificacion"
                    #identificacion="ngModel"
                    [(ngModel)]="tempFilter.identificacion"
                    [class.is-invalid]="identificacion.invalid && filterAttempted"
                    required
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- USERCODE -->
          <div class="col-md-4" *ngIf="selectedProperty?.value === 'userCode'">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="userCode">Codigo de usuario:</label>
                  <input
                    type="text"
                    class="form-control"
                    name="userCode"
                    #userCode="ngModel"
                    [(ngModel)]="tempFilter.userCode"
                    [class.is-invalid]="userCode.invalid && filterAttempted"
                    required
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-1">
            <button type="button" class="btn btn-secondary btn-square align-to-fields" (click)="onFilterAdded()">
              <i-feather name="plus"></i-feather>
            </button>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row clear-margin">
          <div class="filtering-label" *ngIf="saveFilter.identificacion">
            Identificación: {{ saveFilter.identificacion }}
            <button type="button" (click)="onFilterRemoved('identificacion')"><i-feather name="x-circle"></i-feather></button>
          </div>
          <div class="filtering-label" *ngIf="saveFilter.userCode">
            Código de usuario: {{ saveFilter.userCode }}
            <button type="button" (click)="onFilterRemoved('userCode')"><i-feather name="x-circle"></i-feather></button>
          </div>

          <div class="col-md-12 p-0 buttons-wrapper" *ngIf="showForm">
            <button type="submit" class="btn-todos-usuarios" uni-button>Buscar</button>
            <button
              type="button"
              class="btn-todos-usuarios"
              uni-button
              (click)="getAllUsuarios()"
              title="Esta opcion puede tardar un poco debido a la cantidad de registros"
            >
              Todos los usuarios
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
